import React from "react";
import NumberInput from "@/components/NumberInput";
import CustomerPicker from "@/components/CustomerPicker";
import { F } from "../_shared";

export default function StepLead({ q, setQ }) {
  const l = q.lead;
  const upd = (k, v) => setQ((p) => ({ ...p, lead: { ...p.lead, [k]: v } }));
  const attach = (c) => {
    const nm = c.customer_type === "corporate" && c.company_name
      ? c.company_name
      : [c.title, c.first_name, c.middle_name, c.last_name].filter(Boolean).join(" ");
    setQ((p) => ({
      ...p,
      customer_id: c.id,
      customer: { id: c.id, customer_id: c.customer_id, name: nm, email: c.email, mobile: c.mobile },
      lead: {
        ...p.lead,
        name: nm || p.lead.name,
        mobile: c.mobile || p.lead.mobile,
        email: c.email || p.lead.email,
      },
    }));
  };
  const clear = () => setQ((p) => ({ ...p, customer_id: "", customer: null }));
  return (
    <>
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-1.5">Customer (from CRM)</div>
        <CustomerPicker value={q.customer} onPick={attach} onClear={clear} testid="q-customer-picker" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <F label="Package Title (optional)" value={q.package_title} onChange={(v)=>setQ((p)=>({...p, package_title: v}))} testid="pkg-title" />
        <F label="Lead Passenger Name" value={l.name} onChange={(v)=>upd("name", v)} testid="lead-name" />
        <F label="Mobile" value={l.mobile} onChange={(v)=>upd("mobile", v)} testid="lead-mobile" />
        <F label="Email" value={l.email} onChange={(v)=>upd("email", v)} testid="lead-email" />
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-1.5">Adults</div>
          <NumberInput testid="lead-adults" value={l.adults} onChange={(v) => upd("adults", v)} min={1} max={30} placeholder="1" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-1.5">Children</div>
          <NumberInput testid="lead-children" value={l.children} onChange={(v) => upd("children", v)} min={0} max={20} placeholder="0" />
        </div>
      </div>
      {l.children > 0 && (
        <div className="mt-4">
          <label className="block text-xs uppercase tracking-widest text-slate-500 mb-2">Child Ages</label>
          <div className="flex gap-2 flex-wrap">
            {Array.from({length: l.children}).map((_, i) => (
              <div key={i} className="flex flex-col gap-1">
                <div className="text-[10px] uppercase tracking-widest text-slate-400">Child {i + 1}</div>
                <NumberInput
                  testid={`child-age-${i}`}
                  value={l.child_ages?.[i]}
                  placeholder="Age"
                  min={0}
                  max={17}
                  compact
                  onChange={(n) => {
                    const arr = [...(l.child_ages || [])];
                    arr[i] = n;
                    upd("child_ages", arr);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
